import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";

const ViewRecord = ({ isOpen, onClose, record }) => {
  const [viewerUrl, setViewerUrl] = useState(null);

  useEffect(() => {
    if (!record) {
      setViewerUrl(null);
      return;
    }

    try {
      const url = new URL(record);
      const pathname = url.pathname.toLowerCase();

      if (pathname.match(/\.(pdf|doc|docx|xls|xlsx)$/)) {
        const gview = `https://docs.google.com/viewer?url=${encodeURIComponent(
          record
        )}&embedded=true`;
        setViewerUrl(gview);
      } else {
        setViewerUrl(null);
      }
    } catch (err) {
      console.error("Invalid URL:", record);
      setViewerUrl(null);
    }
  }, [record]);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <div className="fixed inset-0 bg-black bg-opacity-50" />

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <div className="flex justify-between items-center mb-4">
              <Dialog.Title className="text-lg font-medium text-gray-900">
                Preview Document
              </Dialog.Title>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                &times;
              </button>
            </div>

            <div className="text-center">
              {record ? (
                viewerUrl ? (
                  <a
                    href={viewerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    Click to View Pdf/Document file
                  </a>
                ) : (
                  <img
                    className="max-w-full rounded"
                    src={record}
                    alt="document preview"
                  />
                )
              ) : (
                ""
              )}
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ViewRecord;
